import Canvas from 'editor/components/Canvas';
import MapboxMap from 'editor/components/map/MapboxMap';
import MapboxOverlay from 'editor/components/map/MapboxOverlay';
import React from 'react';

export interface ECSMapContextContent {
  map: MapboxMap;

  markupsOverlay: MapboxOverlay;

  markupsOverlayCanvas: Canvas;
}

const ECSMapContext = React.createContext<ECSMapContextContent>({
  map: new MapboxMap(),
  markupsOverlay: new MapboxOverlay(),
  markupsOverlayCanvas: new Canvas(),
});

export default ECSMapContext;
